import axios from 'axios';

const HELP_API_PATH = '/help.json';

const getHelp = async () => {
  const url = `${HELP_API_PATH}`;
  return await axios.get(url)
    .then(response => response.data)
    .catch(error => {
      alert('ネットワークの状態が不安定です。\n通信回線の良い状況で再度接続してください')
    });
};

export default getHelp;